import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

const categories = [
  {
    name: "Tarpaulin & Banners",
    items: [
      { title: "Tarpaulin Banner", price: "From ₱25.00 / sq.ft", img: "https://images.unsplash.com/photo-1693031630369-bd429a57f115?crop=entropy&cs=srgb&fm=jpg&q=85&w=600", to: "/order" },
      { title: "Roll-up Banners (Pull-ups)", price: "1 Roll-up — ₱3,271.54 VAT incl.", img: "https://images.pexels.com/photos/6620972/pexels-photo-6620972.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=400&w=600", to: "/order" },
      { title: "Outdoor Mesh Banner", price: "From ₱32.00 / sq.ft", img: "https://images.unsplash.com/photo-1496449903678-68ddcb189a24?w=600&q=80", to: "/order" },
    ],
  },
  {
    name: "Business Print",
    items: [
      { title: "Business Cards (Calling Cards)", price: "100 pcs — ₱1,752.03 VAT incl.", img: "https://images.unsplash.com/photo-1606761568499-6d2451b23c66?w=600&q=80" },
      { title: "Flyers A5", price: "1,000 pcs — ₱8,896.54 VAT incl.", img: "https://images.unsplash.com/photo-1606107557195-0e29a4b5b4aa?w=600&q=80" },
      { title: "Posters A2+", price: "10 pcs — ₱1,714.29 VAT incl.", img: "https://images.unsplash.com/photo-1607013251379-e6eecfffe234?w=600&q=80" },
      { title: "Letterhead A4", price: "1,000 pcs — ₱14,227.17 VAT incl.", img: "https://images.unsplash.com/photo-1517842645767-c639042777db?w=600&q=80" },
      { title: "Envelopes DL", price: "1,000 pcs — ₱16,741.16 VAT incl.", img: "https://images.unsplash.com/photo-1607435097405-db48f377bff6?w=600&q=80" },
      { title: "Brochures (Tri-fold)", price: "500 pcs — ₱9,450.00 VAT incl.", img: "https://images.unsplash.com/photo-1586281380349-632531db7ed4?w=600&q=80" },
    ],
  },
  {
    name: "Stickers & Labels",
    items: [
      { title: "Sticker Labels (2 inch)", price: "100 pcs — ₱914.76 VAT incl.", img: "https://images.unsplash.com/photo-1620207418302-439b387441b0?w=600&q=80" },
      { title: "Thank You Cards", price: "100 pcs — ₱785.17 VAT incl.", img: "https://images.unsplash.com/photo-1607344645866-009c320b63e0?w=600&q=80" },
      { title: "Food Wrapping Paper", price: "1,000 pcs — ₱7,694.66 VAT incl.", img: "https://images.unsplash.com/photo-1571115764595-644a1f56a55c?w=600&q=80" },
    ],
  },
];

const ProductsPage = () => (
  <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 pav-fade-in" data-testid="products-page">
    <div className="mb-10">
      <p className="text-xs uppercase tracking-[0.2em] text-[#06B6D4] font-semibold">Catalog</p>
      <h1 className="font-display text-4xl sm:text-5xl font-extrabold text-[#0B1E3F] mt-2">All products</h1>
      <p className="mt-3 text-neutral-600 max-w-2xl">Browse our most popular print services. For custom tarpaulins, jump straight to the live calculator.</p>
    </div>

    {categories.map((cat) => (
      <section key={cat.name} className="mb-12" data-testid={`category-${cat.name.replace(/\s+/g, "-").toLowerCase()}`}>
        <div className="flex items-end justify-between mb-5">
          <h2 className="font-display text-2xl font-bold text-[#1A1A1A]">{cat.name}</h2>
          {cat.name === "Tarpaulin & Banners" && (
            <Link to="/order" className="text-sm font-semibold text-[#0B1E3F] hover:underline inline-flex items-center gap-1">
              Order tarpaulin now <ArrowRight className="h-4 w-4" />
            </Link>
          )}
        </div>
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 lg:gap-6">
          {cat.items.map((p, idx) => {
            const Card = (
              <div key={p.title} className="pav-card group p-0 overflow-hidden flex flex-col h-full" data-testid={`product-card-${idx}`}>
                <div className="aspect-[4/3] overflow-hidden bg-[#F4F6FB]">
                  <img src={p.img} alt={p.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
                </div>
                <div className="p-4">
                  <h3 className="font-semibold text-[#1A1A1A]">{p.title}</h3>
                  <p className="text-sm text-neutral-500 mt-1">{p.price}</p>
                  {p.to ? null : <p className="text-xs text-neutral-400 mt-3">Contact us for custom quote</p>}
                </div>
              </div>
            );
            return p.to ? <Link to={p.to} key={p.title}>{Card}</Link> : <div key={p.title}>{Card}</div>;
          })}
        </div>
      </section>
    ))}
  </div>
);

export default ProductsPage;
